module.exports = __webpack_public_path__ + "img/logoLinkedin.ef734264.svg";